import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SVG_ICONOS } from './icon-catalogo';

@Injectable({
  providedIn: 'root',
})
export class IconoRegistroService {
  private iconRegistry = inject(MatIconRegistry);
  private sanitizer = inject(DomSanitizer);
  init(): void {
    Object.entries(SVG_ICONOS).forEach(([name, svgLiteral]) => {
      this.iconRegistry.addSvgIconLiteral(name, this.sanitizer.bypassSecurityTrustHtml(svgLiteral));
    });
    console.log('📦 Todos los iconos SVG han sido registrados exitosamente.');
  }
}
